export default __webpack_public_path__ + "static/media/OurGamer1.160c1c33.png";